const notFound = () => {
  return (
    <div className="flex justify-center w-full items-center min-h-[calc(100vh_-_130px)]">
      404 | page Not Found
    </div>
  );
};

export default notFound;
